import React, { useEffect, useState } from 'react';

import { fetchData } from '../../../helpers/methods';
import { formatDateForAgo } from '../../../helpers/date-time';

import SpinnerContainer from '../../../component-library/spinner-container';
import Pagination from '../../../component-library/pagination';
import Tile from '../../../component-library/tile';

const NewsAnnouncements = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const [pagination, setPagination] = useState({
		totalPages: 1,
		currentPage: 1,
	});
	const pageSize = 20;

	const clearAnnouncements = () => {
		const nowDate = new Date();
		const ms = nowDate.valueOf();

		fetchData({
			uri: `/api/web/my/store/announcements/upto/${ms}`,
			method: 'PUT',
		});
	};

	const getData = currentPage => {
		const newCurrentPage = (currentPage - 1);

		fetchData({
			uri: `/api/web/announcements?reverse=true&page=${newCurrentPage}&pageSize=${pageSize}`,
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					if (currentPage === 1) {
						clearAnnouncements();
					}
					const newData = body.announcements;
					setPagination({
						currentPage: body.pageable.number + 1,
						totalPages: Math.ceil(body.pageable.totalElements / pageSize),
					});
					setData(newData);
					setLoading(false);
				} else {
					setLoading(false);
				}
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const handlePagination = currentPage => {
		setPagination({
			...pagination,
			currentPage,
		});
		getData(currentPage);
	};

	const getLink = url => {
		const lowerCaseUrl = url.toLowerCase();
		if (!lowerCaseUrl.startsWith('http')) {
			const newUrl = `http://${url}`;
			return newUrl;
		}
		return url;
	};

	useEffect(() => {
		getData(1);
	}, []);

	return (
		<div>
			{loading && (
				<SpinnerContainer />
			)}
			{!loading && (
				<>
					{data?.length ? (
						data.map((item, index) => (
							// eslint-disable-next-line react/no-array-index-key
							<div className="margin-bottom-16" key={index}>
								<Tile>
									<div className="flex-row justify-space-between align-items-flex-start">
										<h3>
											{item.title}
										</h3>
										<div className="grey-text">{formatDateForAgo(item.published)}</div>
									</div>
									<p className={`${item.externalLinks[0].url?.length > 0 ? '' : 'margin-bottom-none'}`}>{item.details}</p>
									{item.externalLinks[0].url?.length > 0 && (
										<a href={getLink(item.externalLinks[0].url)} target="_blank" rel="noreferrer" className="text-link">
											{item.externalLinks[0].label?.length > 0 ? item.externalLinks[0].label : 'Click for more information'}
										</a>
									)}
								</Tile>
							</div>
						))
					) : (
						<p className="grey-text">No announcements available</p>
					)}
					<Pagination
						totalPages={pagination.totalPages}
						currentPage={pagination.currentPage}
						action={currentPage => handlePagination(currentPage)}
					/>
				</>
			)}
		</div>
	);
};

export default NewsAnnouncements;
